import { jsx as _jsx } from "react/jsx-runtime";
import getLang from 'I18n/utils/getLang';
import { useScript } from '../utils/hooks';
const SURVICATE_SCRIPT_SRC = '//survey.survicate.com/workspaces/3f5708370857710db8227d575391fa24/web_surveys.js';

const ExternalScript = ({
  id,
  src
}) => {
  useScript({
    id,
    src
  });
  return null;
};

const SurvicateSurveyEmbed = () => {
  const isLanguageEnglish = getLang() === 'en';

  if (isLanguageEnglish) {
    return /*#__PURE__*/_jsx(ExternalScript, {
      id: "survicate",
      src: SURVICATE_SCRIPT_SRC
    });
  }

  return null;
};

export default SurvicateSurveyEmbed;